{
  "activity_table": {
    "caption": "Sales history",
    "headings": {
      "date": "Date",
      "order_number": "Order #",
      "type": "Type",
      "shipping_address": "Shipping Address",
      "amount": "Amount"
    },
    "empty_state": {
      "title": "No sales activity",
      "subtitle": "There is no sales activity to show for the selected period."
    },
    "no_shipping_address": "No shipping address available",
    "overflow_warning": "More than 500 orders found, please further limit your date range to view more orders."
  }
}
